class ColorSwatch extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    // Only handle clicks on elements with 'cliquer' class
    const clickedElement = event.target.closest(".cliquer");
    if (!clickedElement) return;

    try {
      const imageValue = clickedElement.getAttribute("data-image");
      const imagehover = clickedElement.getAttribute("data-imagehover");
      const urlValue = clickedElement.getAttribute("data-url");
      const idValue = clickedElement.getAttribute("data-id");

      if (!idValue) {
        console.warn("Missing data-id attribute");
        return;
      }

      // Handle radio button selection
      const radioInput = document.querySelector(
        `label[for="${clickedElement.getAttribute("for")}"]`
      );
      if (radioInput) {
        const productCard = document.querySelector("#" + CSS.escape(idValue));
        const allRadiosInGroup = productCard.querySelectorAll(
          'input[type="radio"]'
        );
        allRadiosInGroup.forEach((radio) => {
          radio.checked = false;
        });

        document.getElementById(
          clickedElement.getAttribute("for")
        ).checked = true;
      }

      // Update product card
      const productCard = document.querySelector("#" + CSS.escape(idValue));
      if (!productCard) return;

      const primaryImage = productCard.querySelector(
        ".prdt-card-image-container img.primary-image"
      );
      const secondaryImage = productCard.querySelector(
        ".prdt-card-image-container img.secondary-image"
      );
      const links = productCard.querySelectorAll("a");

      // Update images
      if (primaryImage && imageValue) {
        primaryImage.src = imageValue;
      }

      if (secondaryImage && imagehover) {
        secondaryImage.src = imagehover;
      }

      // Update links
      if (urlValue) {
        links.forEach((link) => {
          link.href = urlValue;
        });
      }
    } catch (error) {
      console.error("Error updating product display:", error);
    }
  }
}

customElements.define("color-swatch", ColorSwatch);
